import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReportedShipmentPackage } from '../../shared/models/shipments/reported-shipment-package.interface';
import SafeUrlAssembler from 'safe-url-assembler';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { ITrackingResult } from '../../shared/models/shipments/tracking/tracking-result.interface';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';
import {ISearchReportedShipment} from '../../shared/models/shipments/search-reported-shipment.interface';

@Injectable()
export class ReportHistoryService {

  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
  }

  /**
   * Gets reported shipments.
   *
   * @param {string} daysOld
   * @param {string} pageIndex
   * @param {string} pageSize
   * @returns {Observable<IReportedShipmentPackage[]>}
   */
  public getReportedShipments(keyword: string, daysOld?: string, pageIndex?: string, pageSize?: string): Observable<IReportedShipmentPackage[]> {
    const params = {};
    if (daysOld) {
      params['daysOld'] = daysOld;
    }

    if (pageIndex) {
      params['page'] = pageIndex;
    }

    if (pageSize) {
      params['per_page'] = pageSize;
    }

    if (keyword) {
      params['q'] = keyword;
    }

    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getReportedShipments'))
      .query(params)
      .toString();
    return this.httpClientService.get<IReportedShipmentPackage[]>(endpoint);
  }

  public searchReportedShipments(keyword: string, pageIndex?: string, pageSize?: string, ): Observable<ISearchReportedShipment[]> {

    const params = {};
    if (pageIndex) {
      params['page'] = pageIndex;
    }

    if (pageSize) {
      params['per_page'] = pageSize;
    }

    if (keyword) {
      params['q'] = keyword;
    }

    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('searchReportedShipments'))
      .query(params)
      .toString();
    return this.httpClientService.get<ISearchReportedShipment[]>(endpoint);
  }


  /**
   * Deletes the specified reported shipment.
   *
   * @param {string} shipmentId
   * @returns {Observable<any>}
   */
  public deleteReportedShipment(shipmentId: string): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('deleteReportedShipment'))
      .param('shipmentId', shipmentId)
      .toString();
    return this.httpClientService.delete<any>(endpoint);
  }

  /**
   * Gets tracking details.
   *
   * @param {string} shipmentId
   * @param {string} shipmentType
   * @returns {Observable<ITrackingResult>}
   */
  public getTrackingDetails(shipmentId: string, shipmentType?: string): Observable<ITrackingResult> {
    const params = {
      shipmentid: shipmentId,
      shipmenttype: shipmentType || 'web',
    };

    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getTrackingDetails'))
      .query(params)
      .toString();
    return this.httpClientService.get<ITrackingResult>(endpoint);
  }
}
